import { useAppSelector } from 'shared';

export const useCateringEventPageState = (
    () => useAppSelector((store) => store.cateringEventPage)
);
